import React from 'react';
import { Switch } from 'react-router-dom';
import { NotFound } from '../../features/NotFound';
import { PageId } from '../../features/PlatformEvents';
import { routeConfig } from './routeConfig';
import { PageRoute } from './PageRoute';

// eslint-disable-next-line react/jsx-key
const routes = routeConfig.map(props => <PageRoute {...props} />);

// add not found route
routes.push(
  <PageRoute //
    pageId={PageId.NotFound}
    path="/"
    body={NotFound}
  />,
);

export function Routes() {
  return React.createElement(Switch, null, ...routes);
}
